import MainLayout from 'components/layout/MainLayout';
import rewardsBackground from 'assets/images/backgrounds/base_final_reward.png';
import Stickers from './components/Stickers';
import { AppRoutes, ButtonTypes } from 'types';

const SelectSticker: React.FC = () => {
  return (
    <MainLayout
      backgroundImg={rewardsBackground}
      menuProps={{
        primaryLeftButton: {
          name: ButtonTypes.BACK_BUTTON,
          redirectRoute: { path: `/${AppRoutes.REWARDS}`, title: AppRoutes.REWARDS as any },
        },
      }}
    >
      <Stickers />
    </MainLayout>
  );
};

export default SelectSticker;
